// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2QrDZ","label":"SetPasswdForm_label__1JkxO"};